import styled from "@emotion/styled";
import { ThemeProp } from "../../../styles/theme";

export const NetworkDropdownContainer = styled.div<ThemeProp>(({ theme }) => ({
  fontSize: theme.fontSize["5"],
  fontWeight: theme.fontWeights["work-sans-0"],
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1,
}));
